import { APPLICATION_STATUS_TYPE } from '../constants/ApplicationStatusConstants';

const APPLICATION_STATUS_DISPLAY_TEXTS = {
  [APPLICATION_STATUS_TYPE.INVITED]: 'INVITED TO APPLY',
  [APPLICATION_STATUS_TYPE.COMPLETED]: 'RECEIVED',
  [APPLICATION_STATUS_TYPE.PENDING]: 'IN-PROGRESS',
  [APPLICATION_STATUS_TYPE.ACCEPTED]: 'APPROVED',
  [APPLICATION_STATUS_TYPE.CONDITIONALLY_APPROVED]: 'CONDITIONALLY APPROVED',
};

const getDisplayTextForApplicationStatus = (status: string) => {
  switch (status) {
    case APPLICATION_STATUS_TYPE.INVITED:
      return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.INVITED];
    case APPLICATION_STATUS_TYPE.COMPLETED:
      return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.COMPLETED];
    case APPLICATION_STATUS_TYPE.PENDING:
      return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.PENDING];
    case APPLICATION_STATUS_TYPE.ACCEPTED:
      return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.ACCEPTED];
    case APPLICATION_STATUS_TYPE.CONDITIONALLY_APPROVED:
      return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.CONDITIONALLY_APPROVED];
    default:
      return status;
  }
};

export { getDisplayTextForApplicationStatus, APPLICATION_STATUS_TYPE };
